import { SET_NAVIGATION } from "./../actions/types";
export default (
  state = window.location.pathname.split("/").filter(item => item.length > 0),
  action
) => {
  switch (action.type) {
    case SET_NAVIGATION:
      state = action.payload;
      return state;
    default:
      return state;
  }
};
